import { render, staticRenderFns } from "./ConfirmationTypeAdditionals.vue?vue&type=template&id=a8ff1afa&"
import script from "./ConfirmationTypeAdditionals.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConfirmationTypeAdditionals.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ConfirmationTypeAdditionals.vue?vue&type=style&index=0&id=a8ff1afa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports